import { render, staticRenderFns } from "./AddEditTeamRole.vue?vue&type=template&id=e4f9352e&scoped=true"
import script from "./AddEditTeamRole.vue?vue&type=script&lang=js"
export * from "./AddEditTeamRole.vue?vue&type=script&lang=js"
import style0 from "./AddEditTeamRole.vue?vue&type=style&index=0&id=e4f9352e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f9352e",
  null
  
)

export default component.exports